module.exports = __webpack_public_path__ + "img/P150T_weapon_123.371b44af.png";